import StatisticGraphicsModal from './StatisticGraphicsModal';

export default StatisticGraphicsModal;